import Vue from 'vue'
import Router from 'vue-router'

// components
import Startseite from '@/components/Startseite'
import Baurecht from '@/components/content/Baurecht'
import Architektenrecht from '@/components/content/Architektenrecht'
import Zivilrecht from '@/components/content/Zivilrecht'
import Kontakt from '@/components/content/Kontakt'
import Impressum from '@/components/content/Impressum'
import Datenschutz from '@/components/content/Datenschutz'
import Haftungsausschluss from '@/components/content/Haftungsausschluss'
import Kanzleiprofil from '@/components/content/Kanzleiprofil'
import Honorare from '@/components/content/Honorare'
import NeueAdressen from '@/components/bln-content/NeueAdressen'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPos) {
    if (savedPos) return savedPos
    if (to.hash) return { selector: to.hash }
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: Startseite,
      name: 'Startseite'
    },
    {
      path: '/baurecht',
      component: Baurecht,
      name: 'Baurecht'
    },
    {
      path: '/architektenrecht',
      component: Architektenrecht,
      name: 'Architektenrecht'
    },
    {
      path: '/zivilrecht',
      component: Zivilrecht,
      name: 'Zivilrecht'
    },
    {
      path: '/kontakt',
      component: Kontakt,
      name: 'Kontakt'
    },
    {
      path: '/impressum',
      component: Impressum,
      name: 'Impressum'
    },
    {
      path: '/datenschutz',
      component: Datenschutz,
      name: 'Datenschutz'
    },
    {
      path: '/haftungsausschluss',
      component: Haftungsausschluss,
      name: 'Haftungsausschluss'
    },
    {
      path: '/kanzleiprofil',
      component: Kanzleiprofil,
      name: 'Kanzleiprofil'
    },
    {
      path: '/honorare',
      component: Honorare,
      name: 'Honorare'
    },
    {
      path: '/bln',
      component: NeueAdressen,
      name: 'NeueAdressen'
    },
    { path: '*', redirect: { name: 'Startseite' } }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js